// extracted by mini-css-extract-plugin
export default {"image":"MW-z","loaded":"NW-z"};